import { render, staticRenderFns } from "./howToWithDraw.vue?vue&type=template&id=c771a756&scoped=true"
import script from "./howToWithDraw.vue?vue&type=script&lang=js"
export * from "./howToWithDraw.vue?vue&type=script&lang=js"
import style0 from "./howToWithDraw.vue?vue&type=style&index=0&id=c771a756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c771a756",
  null
  
)

export default component.exports